export default __webpack_public_path__ + "static/media/Blackhawks.173f19ab.png";